import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button } from '@ipc/ipc-components';
import { getLeftCheckedMailProcessingCenters, getUserRole } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/InternalRepatriationReportSelectors';
import InternalRepatriationReportSelectionCriteriaContainer
  from './InternalRepatriationReportSelectionCriteriaContainer';
import InternalRepatriationCreateForm from './InternalRepatriationCreateForm';
import { setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';
import { getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';

const leftTree = {
  title: 'Focal Operators and IMPCs',
};

const operators = process.env.relatedOperators;
const relatedOperators = operators.split('|');

class InternalRepatriationReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      showCreateFormModal: false,
      createForm: {
        inboundImpc: '',
        outboundImpc: '',
        inboundOperator: '',
        outboundOperator: '',
      },
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      selectedStartDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'REPORTING_INTERNAL_REPATRIATIONS' },
      this.props.appContext.appContext,
      {
        focals: this.props.leftCheckedMailProcessingCenters,
        startDate: this.state.selectedStartDate,
      },
    );
  };

  showCreateFormModal = () => {
    this.setState({
      showCreateFormModal: true,
    });
  }

  hideCreateFormModal = () => {
    this.setState({
      showCreateFormModal: false,
    });
  }

  onSelectRow = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e) => {
          const { name, checked } = e.target;
          const { createForm } = this.state;
          if (checked) {
            if (name === 'repatFrom') {
              this.setState({
                createForm: {
                  ...createForm,
                  outboundImpc: rowInfo.row.impcCode,
                  outboundOperator: rowInfo.original.operatorCode,
                },
              });
            } else if (name === 'repatTo') {
              this.setState({
                createForm: {
                  ...createForm,
                  inboundImpc: rowInfo.row.impcCode,
                  inboundOperator: rowInfo.original.operatorCode,
                },
              });
            }
          }
        },
      };
    }
    return {};
  };

  render() {
    const { isLoading, data, columns } = this.props;
    const {
      createForm: {
        inboundImpc,
        outboundImpc,
        inboundOperator,
        outboundOperator,
      },
      createForm,
      showResult,
      selectedStartDate,
      showCreateFormModal,
    } = this.state;

    return (
      <div>
        <InternalRepatriationReportSelectionCriteriaContainer
          open={data.length === 0}
          title="INTERNAL REPATRIATIONS"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          leftTree={leftTree}
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
                || this.props.userRole.includes('IPC_TRAY_MANAGER')
                || this.props.userRole.includes('IPC_BAG_MANAGER')
                || this.props.userRole.includes('NATIONAL_PALLET_BOX_COORDINATOR')
                || this.props.userRole.includes('NATIONAL_TRAY_COORDINATOR')
                || this.props.userRole.includes('NATIONAL_BAG_COORDINATOR'))
              && ((inboundImpc && outboundImpc) && (inboundImpc !== outboundImpc)
                && ((inboundOperator === outboundOperator) || (relatedOperators.includes(inboundOperator) && relatedOperators.includes(outboundOperator)))) && (
                <Button
                  onClick={this.showCreateFormModal}
                  className="primary-button-false"
                  style={{ margin: '10px' }}
                >
                  Create Internal Repatriation
                </Button>
              )}
              {(this.props.userRole.includes('MANAGER')
                || this.props.userRole.includes('IPC_TRAY_MANAGER')
                || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
                <a href={process.env.repatriationCostSheetUrl} target="_blank" rel="noreferrer" className="choice">
                  <Button
                    className="action-buttons"
                    disabled={process.env.repatriationCostSheetUrl === undefined || process.env.repatriationCostSheetUrl === ''}
                    style={{ margin: '10px' }}
                  >
                    Open Cost Sheet
                  </Button>
                </a>
              )}
              <div className="list-table-container" style={{ paddingBottom: '20px', minHeight: '740px' }}>
                <ListTable
                  listId={TableDefinitions.REPORTING_INTERNAL_REPATRIATIONS.id}
                  loading={isLoading}
                  columns={columns}
                  data={data}
                  getTrProps={this.onSelectRow}
                  pagination
                />
              </div>
            </div>
          )}
          {showCreateFormModal && (
            <InternalRepatriationCreateForm
              closeDialog={this.hideCreateFormModal}
              row={this.props}
              openDialog={this.showCreateFormModal}
              data={createForm}
            />
          )}
        </div>
      </div>
    );
  }
}

InternalRepatriationReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
  globalStartDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
    globalStartDate: getGlobalStartDate(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalRepatriationReportContainer);
